import { Box, Button } from "@mui/material";
import { grey, indigo } from "../../../colors";

export default function FilterDrawerControls({
  hasActiveFilters,
  hasUnappliedChanges,
  onClickReset,
  onClickApply,
}: {
  hasActiveFilters: boolean;
  hasUnappliedChanges: boolean;
  onClickReset: () => void;
  onClickApply: () => void;
}) {
  if (!hasActiveFilters && !hasUnappliedChanges) return null;

  return (
    <Box sx={{ p: 1.5, display: "flex", gap: 1 }}>
      <Button
        variant="outlined"
        fullWidth
        onClick={onClickReset}
        sx={{
          borderRadius: "32px",
          textTransform: "none",
          fontWeight: 500,
          color: indigo[700],
          borderColor: indigo[100],
          display: "flex",
          justifyContent: "center",
          "&:hover": { borderColor: indigo[300], backgroundColor: indigo[50] },
        }}
      >
        Reset
      </Button>
      <Button
        variant="contained"
        fullWidth
        disableElevation
        disabled={!hasUnappliedChanges}
        onClick={onClickApply}
        sx={{
          borderRadius: "32px",
          textTransform: "none",
          fontWeight: 500,
          display: "flex",
          justifyContent: "center",
          backgroundColor: indigo[700],
          color: "#fff",
          "&:hover": { backgroundColor: indigo[800] },
          "&.Mui-disabled": { backgroundColor: grey[100], color: grey[500] },
        }}
      >
        Apply Filters
      </Button>
    </Box>
  );
}
